<script>
	import { base } from '$app/paths';
	import { page } from '$app/stores';
	import guides from './guides.json';
	import '../../kdmgen/help/help.css';
</script>

<div class="kdm-help slate-help">
	<nav class="help-nav" aria-label="Slate Tools help guides">
		<a
			href={`${base}/slate/help/`}
			aria-current={$page.url.pathname === `${base}/slate/help/` ? 'page' : undefined}
			>Walk Throughs/Help</a
		>
		{#each guides as guide}
			<a
				href={`${base}/slate/help/${guide.slug}/`}
				aria-current={$page.url.pathname === `${base}/slate/help/${guide.slug}/`
					? 'page'
					: undefined}>{guide.title}</a
			>
		{/each}
	</nav>
	<slot />
</div>
